var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServices4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "services4",
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.499,
    height: 43.499,
    viewBox: "0 0 43.499 43.499",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_192",
    "data-name": "Path 192",
    d: "M39.925,16A19.589,19.589,0,0,0,21.22,41.36l-4.17-2.085a.725.725,0,1,0-.649,1.3l5.8,2.9a.725.725,0,0,0,.837-.136l4.35-4.35a.725.725,0,0,0-1.025-1.025L22.8,41.523A18.127,18.127,0,1,1,39.925,53.7a.725.725,0,1,0,0,1.45,19.574,19.574,0,0,0,0-39.149Z",
    transform: "translate(-16 -15.999)",
    fill: "#1d2547"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_193",
    "data-name": "Path 193",
    d: "M176.055,177.7a.725.725,0,0,0,.67.448h7.25a.725.725,0,1,0,0-1.45h-5.5l5.287-5.287a.725.725,0,0,0,.212-.513c0-1.6-1.626-2.9-3.625-2.9s-3.625,1.3-3.625,2.9a.725.725,0,0,0,1.45,0c0-.786,1-1.45,2.175-1.45a2.159,2.159,0,0,1,2.137,1.187l-6.275,6.275A.725.725,0,0,0,176.055,177.7Z",
    transform: "translate(-161.5 -154.225)",
    fill: "#1d2547"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_194",
    "data-name": "Path 194",
    d: "M406.7,135.907a.725.725,0,1,0-1.208.8c.253.381.49.779.7,1.183a.725.725,0,0,0,1.282-.678C407.241,136.768,406.98,136.328,406.7,135.907Z",
    transform: "translate(-370.085 -124.746)",
    fill: "#1d2547"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_195",
    "data-name": "Path 195",
    d: "M426.98,179.437a.725.725,0,1,0-1.391.408q.193.661.32,1.338a.725.725,0,0,0,1.425-.266A15.2,15.2,0,0,0,426.98,179.437Z",
    transform: "translate(-388.444 -164.152)",
    fill: "#1d2547"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_196",
    "data-name": "Path 196",
    d: "M420.858,271.305a.725.725,0,0,0-.906.479,13.746,13.746,0,0,1-.472,1.293.725.725,0,0,0,1.335.565,15.19,15.19,0,0,0,.522-1.43A.725.725,0,0,0,420.858,271.305Z",
    transform: "translate(-382.864 -248.139)",
    fill: "#1d2547"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_197",
    "data-name": "Path 197",
    d: "M374.472,100.3a.725.725,0,0,0-.918,1.122,13.763,13.763,0,0,1,1.021.924.725.725,0,1,0,1.026-1.025C375.243,100.963,374.864,100.62,374.472,100.3Z",
    transform: "translate(-340.909 -92.511)",
    fill: "#1d2547"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_198",
    "data-name": "Path 198",
    d: "M394.667,316.748a.725.725,0,0,0,1.021-.087c.326-.386.636-.794.921-1.211a.725.725,0,1,0-1.2-.82c-.259.377-.539.746-.834,1.1A.725.725,0,0,0,394.667,316.748Z",
    transform: "translate(-360.117 -287.281)",
    fill: "#1d2547"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_199",
    "data-name": "Path 199",
    d: "M432.66,226.243c.05-.5.075-1.012.075-1.518a.725.725,0,1,0-1.45,0c0,.459-.023.921-.068,1.376a.725.725,0,0,0,.65.793c.024,0,.048,0,.073,0A.725.725,0,0,0,432.66,226.243Z",
    transform: "translate(-393.586 -205.15)",
    fill: "#1d2547"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_200",
    "data-name": "Path 200",
    d: "M238.7,66.712a.731.731,0,0,0,.154-.017,13.756,13.756,0,0,1,1.358-.223.725.725,0,0,0-.163-1.441c-.5.057-1.008.14-1.5.247a.725.725,0,0,0,.153,1.434Z",
    transform: "translate(-217.862 -60.584)",
    fill: "#1d2547"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_201",
    "data-name": "Path 201",
    d: "M144.044,321.041c.3.4.63.8.972,1.17a.725.725,0,1,0,1.068-.981c-.309-.337-.605-.693-.88-1.059a.725.725,0,0,0-1.16.87Z",
    transform: "translate(-132.308 -292.342)",
    fill: "#1d2547"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_202",
    "data-name": "Path 202",
    d: "M115.152,183.336a.725.725,0,0,0-.885.517,15.205,15.205,0,0,0-.311,1.49.725.725,0,1,0,1.432.225,13.755,13.755,0,0,1,.281-1.347A.725.725,0,0,0,115.152,183.336Z",
    transform: "translate(-105.071 -168.15)",
    fill: "#1d2547"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_203",
    "data-name": "Path 203",
    d: "M333.885,77.682a.725.725,0,1,0,.678-1.282,15.161,15.161,0,0,0-1.379-.643.725.725,0,0,0-.546,1.343A13.755,13.755,0,0,1,333.885,77.682Z",
    transform: "translate(-303.532 -70.293)",
    fill: "#1d2547"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_204",
    "data-name": "Path 204",
    d: "M129.757,141.728a13.758,13.758,0,0,1,.669-1.2.725.725,0,1,0-1.23-.768c-.268.429-.516.876-.74,1.33a.725.725,0,0,0,1.3.641Z",
    transform: "translate(-118.197 -128.232)",
    fill: "#1d2547"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_205",
    "data-name": "Path 205",
    d: "M194.044,79.582a.722.722,0,0,0,.356-.094c.4-.225.812-.433,1.23-.617a.725.725,0,1,0-.584-1.327,15.208,15.208,0,0,0-1.36.682.725.725,0,0,0,.358,1.356Z",
    transform: "translate(-177.249 -71.911)",
    fill: "#1d2547"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_206",
    "data-name": "Path 206",
    d: "M359.958,349.461c-.358.285-.735.555-1.119.8a.725.725,0,1,0,.785,1.219c.425-.274.841-.572,1.236-.886a.725.725,0,1,0-.9-1.135Z",
    transform: "translate(-327.467 -319.099)",
    fill: "#1d2547"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_207",
    "data-name": "Path 207",
    d: "M316.719,373.19a13.724,13.724,0,0,1-1.306.434.725.725,0,0,0,.388,1.4,15.172,15.172,0,0,0,1.444-.48.725.725,0,0,0-.526-1.351Z",
    transform: "translate(-287.797 -340.776)",
    fill: "#1d2547"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_208",
    "data-name": "Path 208",
    d: "M179.1,353.588a.725.725,0,0,0-.853,1.172c.409.3.837.578,1.273.833a.725.725,0,0,0,.732-1.252C179.854,354.111,179.466,353.858,179.1,353.588Z",
    transform: "translate(-163.269 -322.869)",
    fill: "#1d2547"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_209",
    "data-name": "Path 209",
    d: "M268.066,383.633h-.021a.725.725,0,1,0-.02,1.45c.144,0,.29.006.435.006.362,0,.727-.013,1.085-.038a.725.725,0,1,0-.1-1.446C268.989,383.636,268.523,383.646,268.066,383.633Z",
    transform: "translate(-244.536 -350.29)",
    fill: "#1d2547"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_210",
    "data-name": "Path 210",
    d: "M156.98,103.248c-.382.331-.751.685-1.1,1.052a.725.725,0,0,0,1.054,1c.314-.332.649-.653.994-.953a.725.725,0,0,0-.95-1.1Z",
    transform: "translate(-143.025 -95.18)",
    fill: "#1d2547"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_211",
    "data-name": "Path 211",
    d: "M221.332,375.525a.725.725,0,0,0-.468,1.372,15.221,15.221,0,0,0,1.464.418.725.725,0,0,0,.327-1.413A13.726,13.726,0,0,1,221.332,375.525Z",
    transform: "translate(-201.852 -342.908)",
    fill: "#1d2547"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_212",
    "data-name": "Path 212",
    d: "M287.989,64.784c-.5-.093-1-.161-1.508-.2a.725.725,0,0,0-.122,1.445c.456.039.915.1,1.364.185a.725.725,0,1,0,.266-1.425Z",
    transform: "translate(-261.255 -60.175)",
    fill: "#1d2547"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_213",
    "data-name": "Path 213",
    d: "M30.5,378.875v-7.25a.725.725,0,0,0-.725-.725H27.6v-2.175a.725.725,0,0,0-.725-.725h-7.25a.725.725,0,0,0-.725.725V370.9H16.725a.725.725,0,0,0-.725.725v7.25a.725.725,0,0,0,.725.725h13.05A.725.725,0,0,0,30.5,378.875Zm-11.6-.725H17.45v-5.8H18.9Zm7.25,0H23.975v-.725a.725.725,0,0,0-1.45,0v.725H20.35v-8.7h5.8Zm2.9,0H27.6v-5.8h1.45Z",
    transform: "translate(-16 -336.101)",
    fill: "#1d2547"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_214",
    "data-name": "Path 214",
    d: "M80.725,401.45h1.45a.725.725,0,0,0,0-1.45h-1.45a.725.725,0,0,0,0,1.45Z",
    transform: "translate(-74.2 -365.201)",
    fill: "#1d2547"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_215",
    "data-name": "Path 215",
    d: "M80.725,433.45h1.45a.725.725,0,1,0,0-1.45h-1.45a.725.725,0,1,0,0,1.45Z",
    transform: "translate(-74.2 -394.301)",
    fill: "#1d2547"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_216",
    "data-name": "Path 216",
    d: "M288.064,174.824a.725.725,0,0,0,.66.425h4.35v2.175a.725.725,0,1,0,1.45,0v-2.175h1.45a.725.725,0,0,0,0-1.45h-1.45v-5.075a.725.725,0,0,0-1.271-.477l-5.075,5.8A.725.725,0,0,0,288.064,174.824Zm5.01-4.17V173.8h-2.752Z",
    transform: "translate(-263.35 -154.225)",
    fill: "#1d2547"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServices4);
export default __webpack_public_path__ + "static/media/services4.c38deea2952ce07e22fba5e0d7d490cc.svg";
export { ForwardRef as ReactComponent };